import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, mergeProps as _mergeProps, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "event-list__modal-wrapper" }
const _hoisted_2 = { class: "event-list__modal-head" }
const _hoisted_3 = { class: "event-list__modal-head-title" }
const _hoisted_4 = { class: "event-list__filters-wrapper" }
const _hoisted_5 = { class: "event-list__kind-filter" }
const _hoisted_6 = { class: "event-list__kind-filter-label" }
const _hoisted_7 = { class: "event-list__calendar-filter" }
const _hoisted_8 = { class: "event-list__calendar-filter-box" }
const _hoisted_9 = { class: "event-list-calendar-filer-feature" }
const _hoisted_10 = { class: "event-list__modal-scroll-container" }
const _hoisted_11 = { class: "event-list__modal-scroll-content" }
const _hoisted_12 = { class: "event-list__date" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_translated_text_component = _resolveComponent("translated-text-component")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_date_picker = _resolveComponent("v-date-picker")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_Event = _resolveComponent("Event")!

  return (_ctx.show)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.stopCloseHandler && _ctx.stopCloseHandler(...args)), ["stop"])),
        class: "event-list__modal"
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h3", _hoisted_3, [
              _createVNode(_component_translated_text_component, { translation: "modal_event_list_title" })
            ]),
            _createVNode(_component_v_btn, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeEventListModal())),
              class: "event-list__modal-close-btn",
              icon: "mdi mdi-close",
              variant: "text"
            }),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.eventCategories, (category) => {
                  return (_openBlock(), _createBlock(_component_v_btn, {
                    key: category.key,
                    onClick: ($event: any) => (_ctx.updateEventCategorySwitcher(category.key, !_ctx.eventCategorySwichers[category.key])),
                    class: _normalizeClass([{'--inactive': !_ctx.eventCategorySwichers[category.key]}, "event-list__kind-filter-btn"]),
                    size: "small",
                    color: "primary"
                  }, {
                    default: _withCtx(() => [
                      (category.icon_code)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "event-list__kind-filter-btn-icon",
                            style: _normalizeStyle(`mask: url(data:image/svg+xml;base64,${category.icon_code}) no-repeat center; mask-size: contain;`)
                          }, null, 4))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_translated_text_component, {
                          translation: `EVENT_CATEGORY_NAME_${category.key}`
                        }, null, 8, ["translation"])
                      ])
                    ]),
                    _: 2
                  }, 1032, ["onClick", "class"]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_v_btn, {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.prevDay())),
                  class: "mx-2",
                  color: "primary"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, { color: "buttonIcons" }, {
                      default: _withCtx(() => _cache[7] || (_cache[7] = [
                        _createTextVNode(" mdi-arrow-left-bold ")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_v_menu, {
                      modelValue: _ctx.showDatePickerMenu,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showDatePickerMenu) = $event)),
                      "close-on-content-click": false,
                      "offset-y": ""
                    }, {
                      activator: _withCtx(({ props }) => [
                        _createVNode(_component_v_text_field, _mergeProps({
                          class: "no-msg arrival-select",
                          value: _ctx.formattedDate,
                          "prepend-inner-icon": "mdi-calendar",
                          readonly: "",
                          solo: "",
                          density: "compact",
                          "hide-details": ""
                        }, props, { size: "" }), null, 16, ["value"])
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_v_date_picker, {
                          modelValue: _ctx.currentDateTime,
                          "onUpdate:modelValue": [
                            _cache[2] || (_cache[2] = ($event: any) => ((_ctx.currentDateTime) = $event)),
                            _cache[3] || (_cache[3] = ($event: any) => (_ctx.showDatePickerMenu = false))
                          ],
                          onInput: _ctx.onDateSelected,
                          color: "primary",
                          width: "300"
                        }, null, 8, ["modelValue", "onInput"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ]),
                _createVNode(_component_v_btn, {
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.nextDay())),
                  class: "mx-2",
                  color: "primary"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, { color: "buttonIcons" }, {
                      default: _withCtx(() => _cache[8] || (_cache[8] = [
                        _createTextVNode(" mdi-arrow-right-bold ")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderedDays, (date) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "event-list__day",
                  key: date
                }, [
                  _createElementVNode("div", _hoisted_12, _toDisplayString(date), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupedEvents[date], (singleEvent) => {
                    return (_openBlock(), _createBlock(_component_Event, {
                      key: singleEvent.name,
                      data: singleEvent
                    }, null, 8, ["data"]))
                  }), 128))
                ]))
              }), 128))
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}